import { Link } from "react-router-dom";

import translate from "../../../../services/Translate";

export const transformMeetingLog = (event: any, language: string) => {
  const type = event.target?.type;

  switch (type) {
    case "user_attendance": {
      const statusMap: Record<string, string> = {
        forgotten_signature: translate(language, "PAGES.MEETING.LOGS.ATTENDANCE.STATUSES.FORGOTTEN_SIGNATURE"),
        justified_absence: translate(language, "PAGES.MEETING.LOGS.ATTENDANCE.STATUSES.JUSTIFIED_ABSENCE"),
        True: translate(language, "PAGES.MEETING.LOGS.ATTENDANCE.STATUSES.PRESENT"),
        False: translate(language, "PAGES.MEETING.LOGS.ATTENDANCE.STATUSES.ABSENT"),
      };

      return {
        items: event.target.items.map((item: any) => {
          const status = item.status ? statusMap[item.status] || item.status : null;

          return {
            key: "user_attendance",
            value: (
              <span>
                <Link to={`/user/${item.id}`} className="fw-semibold text-decoration-none">
                  {item.name || translate(language, "PAGES.MEETING.LOGS.ATTENDANCE.DELETED_USER")}
                </Link>
                {status ? ` — ${status}` : ""}
              </span>
            ),
          };
        }),
      };
    }

    case "cohort_attendance":
      return {
        items: event.target.items.map((item: any) => ({
          key: "cohort_attendance",
          value: (
            <Link to={`/cohort/${item.id}`} className="fw-semibold text-decoration-none">
              {item.name || translate(language, "PAGES.MEETING.LOGS.ATTENDANCE.DELETED_COHORT")}
            </Link>
          ),
        })),
      };

    case "animators":
      return {
        items: event.target.items.map((item: any) => ({
          key: "animators",
          value: (
            <Link to={`/user/${item.id}`} className="fw-semibold text-decoration-none">
              {item.name}
            </Link>
          ),
        })),
      };

    case "resource": {
      const labelMap: Record<string, string> = {
        resource_id: "resource.id",
        name: "resource.name",
        url: "resource.url",
        is_public: "resource.is_public",
      };

      return {
        items: event.target.items.map((item: any) => ({
          key: labelMap[item.name] || item.name || type,
          value: item.id,
        })),
      };
    }

    case "attendance": {
      const valueMap: Record<string, string> = {
        locked: translate(language, "PAGES.MEETING.LOGS.ATTENDANCE.VALUES.LOCKED"),
        link: translate(language, "PAGES.MEETING.LOGS.ATTENDANCE.VALUES.LINK"),
      };

      return {
        items: event.target.items.map((item: any) => ({
          key: "attendance",
          value: valueMap[String(item.id).toLowerCase()] || item.id,
        })),
      };
    }

    default:
      return {
        items: event.target.items.map((item: any) => ({
          key: item.name || type,
          value: item.id,
        })),
      };
  }
};
